export default "__VITE_ASSET__DrLv02bP__"